<template>
  <v-dialog v-model="showModal" width="500" persistent scrollable v-if="question">
      <v-card>
        <v-card-title class="headline"> Update Question
          <v-tooltip bottom v-if="question.removable">
            <template slot="activator">
              <v-icon small color="grey lighten-1">lock</v-icon>
            </template>
            <span>Question blocked, because is associated with other rounds</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="saveQuestion">
            <v-text-field
              v-model="question.title"
              :counter="500"
              label="Title"
              v-validate="'required|max:500'"
              :error-messages="errors.collect('title')"
              data-vv-name="title"
            ></v-text-field>

            <v-select
              :items="types"
              v-model="question.type"
              label="Type"
              disabled
              required v-validate="'required'"
              :error-messages="errors.collect('type')"
              data-vv-name="type"
              @input="clearOptions()"
            ></v-select>

            <div v-if="question.type === 'CHECK' || question.type === 'RADIO' || question.type === 'LIST'" >
              <v-layout row wrap align-center justify-space-between v-for="(option, index) in question.options" :key="index">
                <v-flex xs10>
                  <v-text-field
                    v-model="option.title"
                    :counter="190"
                    label="Enter an option"
                    type="text"
                    :key="'title' + index"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="text-right">
                  <v-btn color="red" fab small class="mr-0" @click="deleteOption(index)" :disabled="question.removable">
                    <v-icon color="white">delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-btn color="primary" block @click="addOptions" :disabled="question.removable">
                Add New option
              </v-btn>
            </div>

            <div v-if ="question.type == 'LIST'">
              <hr>
              <!--
              <v-text-field
                v-model="itemList"
                :counter="190"
                label="Enter an options separate with ',' "
                type="text"
              ></v-text-field>
              -->

              <v-select
                :items="previewList"
                label="Options"
                data-vv-name="option"
              ></v-select>
            </div>

            <div v-if="question.type === 'NUMERAL'">
              <v-layout row wrap align-center justify-space-between v-for="(option, index) in question.options" :key="index">
                <v-flex xs10>
                  <v-text-field
                    v-model="option.title"
                    :counter="190"
                    label="Enter an title"
                    type="text"
                    :key="'title' + index">
                  </v-text-field>
                </v-flex>
                <v-flex xs2 class="text-right">
                  <v-btn color="green" fab small class="mr-0">
                    <span class="white--text">{{option.value}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>

            <div v-if="question.type === 'SMILEY'">
              <v-layout row wrap align-center justify-space-between v-for="(option, index) in question.options" :key="index">
                <v-flex xs10>
                  <v-text-field
                    v-model="option.title"
                    :counter="190"
                    label="Enter an title"
                    type="text"
                    :key="'title' + index"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="text-right">
                  <v-btn color="green" fab small class="mr-0">
                    <span class="white--text">{{option.value}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>

          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="closeModalQuestion">Close</v-btn>
          <v-btn color="primary" @click="saveQuestion">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    questionId: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      question: null,
      types: ['NPS', 'RADIO', 'TEXT', 'SMILEY', 'LIST', 'NUMERAL', 'CHECK'],
      itemList: '',
      listDefaultNumeral: [
        {
          title: 'Totally satisfied',
          value: '5',
        },
        {
          title: 'Very satisfied',
          value: '4',
        },
        {
          title: 'Satisfied',
          value: '3',
        },
        {
          title: 'Little satisfied',
          value: '2',
        },
        {
          title: 'Not satisfied',
          value: '1',
        }
      ],
      listDefaultSmileys: [
        {
          title: 'Excellent',
          value: '5',
        },
        {
          title: 'Good',
          value: '4',
        },
        {
          title: 'Neutral',
          value: '3',
        },
        {
          title: 'Bad',
          value: '2',
        },
        {
          title: 'Very bad',
          value: '1',
        }
      ]
    };
  },
  computed: {
    previewList: function () {
      return this.question.options.map((option) => {
        return option.title;
      });
    }
  },
  watch: {
    question: function (val) {
    }
  },
  mounted () {
    this.editQuestion();
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    ...mapActions('question', [
      'callUpdateQuestion'
    ]),
    editQuestion () {
      const url = '/questions/' + this.questionId + '/edit';
      window.axios.get(url).then((response) => {
        this.question = response.data.data;
      }).catch((error) => {
        console.log(error);
      });
    
    },
    addOptions () {
      this.question.options.push({
        id: this.generateUuid(),
        question_id: this.question.id,
        title: 'Option Title',
        value: null,
        order: this.question.options.length + 1
      });
    },
    deleteOption (index) {
      this.question.options.splice(index, 1);
    },
    saveQuestion () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const url = '/questions/' + this.questionId;
          let payload = {
            title: this.question.title,
            type: this.question.type,
            options: this.question.options
          };
          
          this.setLoading(true);

          window.axios.put(url, payload).then((response) => {
            let questionUpdated = response.data.data;
            this.setLoading(false);
            this.$emit('update-question', {
              'question': questionUpdated,
              'index': this.index
            });
            this.$emit('close-modal-edit');
          }).catch((error) => {
            this.setLoading(false);
          });
        } else {
          this.setSnackbar({
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    },
    closeModalQuestion () {
      this.$emit('close-modal-edit');
    },
    clearOptions () {
      this.options = [];
      if (this.type === 'SMILEY') {
        this.options = this.listDefaultSmileys;
      }
      if (this.type === 'NUMERAL') {
        this.options = this.listDefaultNumeral;
      }
    },
    generateUuid () {
      let value = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return value;
    },
  }
};
</script>
<style>
  .text-right{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/questions/modals/EditQuestion.vue